import { useMemo, useState, useEffect } from 'react';
import moment from 'moment';
import { getValidDateType, getValidDateValue, getMomentDateValue } from '../utils';
import { ComposedDateMode } from '../enums';

import type { IDateType, IDateValue, IMomentDateValue } from '@/pages/intelligence/types/common';

export default function useRangePicker(config: {
  mode: ComposedDateMode;
  dateType: IDateType;
  dateValue: IDateValue;
  onChange?: (mode: ComposedDateMode, dateType: IDateType, dateValue: IDateValue) => void;
}) {
  const { mode, dateType: dateTypeOutter, dateValue: dateValueOutter, onChange } = config || {};

  // const validDateType = mode === ComposedDateMode.Absolute ? getValidDateType(dateTypeOutter) : 'date';
  const validDateType = getValidDateType(dateTypeOutter);
  const validDateValue = mode === ComposedDateMode.Absolute ? getValidDateValue(dateValueOutter) : [];

  const [dateType, setDateType] = useState<IDateType>(validDateType);
  const [dateValue, setDateValue] = useState<IDateValue>(validDateValue);
  const pickerDateValue = useMemo<IMomentDateValue>(() => getMomentDateValue(dateValue), [dateValue]);

  const handleChange = (dateValuePayload: IMomentDateValue, dateTypePayload: IDateType) => {
    let dateValueTemp = dateValuePayload;
    /*
    if (dateTypePayload !== dateType) {
      if (dateTypePayload === 'date') {
        const lastDay = moment()?.subtract(1, 'days');
        const last30Day = moment()?.subtract(30, 'days');
        dateValueTemp = [last30Day, lastDay];
      } else if (dateTypePayload === 'week') {
        const lastWeek = moment()?.subtract(1, 'weeks');
        const last4Week = moment()?.subtract(7, 'weeks');
        const startOfLast4Week = moment(last4Week)?.startOf('week');
        const endOfLastWeek = moment(lastWeek)?.endOf('week');
        dateValueTemp = [startOfLast4Week, endOfLastWeek];
      } else if (dateTypePayload === 'month') {
        const lastMonth = moment()?.subtract(1, 'months');
        const last6Month = moment()?.subtract(6, 'months');
        const startOfLast6Month = moment(last6Month)?.startOf('month');
        const endOfLastMonth = moment(lastMonth)?.endOf('month');
        dateValueTemp = [startOfLast6Month, endOfLastMonth];
      }
    }
    */
    const dateValueStr = dateValueTemp?.map((item) => item.format('YYYY-MM-DD'));
    setDateType(dateTypePayload);
    setDateValue(dateValueStr);
    onChange?.(ComposedDateMode.Absolute, dateTypePayload, dateValueStr);
  };

  useEffect(() => {
    if (mode !== ComposedDateMode.Absolute) return;
    const validDateType = getValidDateType(dateTypeOutter);
    const validDateValue = getValidDateValue(dateValueOutter);
    setDateType(validDateType);
    setDateValue(validDateValue);
  }, [dateTypeOutter, dateValueOutter]);

  return {
    dateType,
    dateValue,
    pickerDateValue,
    onChange: handleChange,
  };
}
